import { render, staticRenderFns } from "./SumExpensesByCategory.vue?vue&type=template&id=2a56e195"
import script from "./SumExpensesByCategory.vue?vue&type=script&lang=js"
export * from "./SumExpensesByCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports